<template>
  <div class="home">
    <TabBar />
    <div class="banner"></div>

    <!-- 万物物联 -->
    <div class="home_item">
      <div class="container">
        <div class="home_item_content">
          <h6>All content couplet</h6>
          <i></i>
          <h1>万物物联</h1>
          <span class="wulian">万物互联，即物物互联，又称智慧物联。</span>
          <div class="content">
            <p>简单而言：它就是为所有的硬件联网，将人，流程，数据和事物结合一起，使得物体不再冰冷，而是聪明的明白客户所需，更加高效便捷的解决问题，从而提供更舒适的使用体验。</p>
            <p>专业来讲：万物物联包括三层结构，分别是软件系统（移动的APP、智能云计算系统）、接口（数据文档）、硬件系统（物联网智能控制模块）。</p>
            <p>物联网有两大基础，一是需要具备网络。二是，需要专业传感器+模块。</p>
            <p>网络且不必说了，5G即来， 早为物联网的发展奠定了强大基础。</p>
            <p>我们来看传感器。传感器呢，就是让物体能够感知网络信号并做出对应的反馈和处理。它是物联网的眼睛，耳朵和鼻子，让物体能够感受声音，感受颜色，感受温度，感受距离，感受海拔和天涯海角……模块则是传感器发挥强大功能的必需媒介。</p>
            <p>试想一下，当网络信号无处不在的时候，我们为每个物体都配上一个专业模块 + 传感器，这个市场得有多大呢？</p>
          </div>
          <div class="more">
            <router-link tag="a" to="/product/wanwu" href="#">查看更多</router-link>
            <img src="../assets/images/right.png" alt />
          </div>
        </div>
        <div class="wanwu_img">
          <img src="../assets/images/home_wanwu.png" alt />
        </div>
      </div>
    </div>

    <!-- 智能机器人 -->
    <div class="home_item">
      <div class="container">
        <div class="robot_img">
          <img src="../assets/images/home_robot.png" alt />
          <img src="../assets/images/home_robot_2.png" alt />
        </div>
        <div class="home_item_content">
          <h6>Intelligent robot</h6>
          <i></i>
          <h1>智能机器人</h1>
          <p class="content_2">
            什么是智能机器人？
            <br />智能机器人是相对传统机器人新产生的概念。
          </p>
          <div class="robot_content">
            <p>传统机器人是在编程控制下实现简单的操作功能，智能机器人则是给机器人装上了“大脑芯片”，使其具备深度学习能力及自主决策力，能够根据环境自我调节。</p>
          </div>
          <div class="more">
            <router-link tag="a" to="/product/robot" href="#">查看更多</router-link>
            <img src="../assets/images/right.png" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- 安全防护，保驾护航 -->
    <div class="home_item">
      <div class="container">
        <div class="home_item_content safty_item_content">
          <h6>Safety protection</h6>
          <i></i>
          <h1>安全防护</h1>
          <h1>保驾护航</h1>
          <div class="content safty_content">
            <p>随着数据广泛、多源性的收集，大数据自身安全及个人信息保护带来了新挑战。个人信息过度收集、未履行告知义务等现象侵害着企业和个人的合法权益。</p>
            <br />
            <p>远达智能科技承诺：我们在开发模块的同时，致力于防护安全问题，数据采集各个流程阶段，都会注重用户隐私，杜绝不文明网络攻击，坚守互联网最后底线。</p>
          </div>
        </div>
        <div class="satfyBox">
          <div class="safty_item">
            <div class="safty_item_img">
              <img src="../assets/images/data_collect.png" alt />
            </div>
            <h2>数据采集安全</h2>
            <p>通过数据安全管理、数据类型和安全等级打标，将相应功能内嵌入后台的数据管理系统，或与其无缝对接，从而保证网络安全。</p>
          </div>
          <div class="safty_item">
            <div class="safty_item_img">
              <img src="../assets/images/data_safe.png" alt />
            </div>
            <h2>数据存储及传输安全</h2>
            <p>在数据传输环节，建立不同安全域间的加密传输链路，也可直接对数据进行加密，以密文形式传输，保障传输过程安全。</p>
          </div>
          <div class="safty_item">
            <div class="safty_item_img">
              <img src="../assets/images/data_use.png" alt />
            </div>
            <h2>数据应用安全</h2>
            <p>对账号统一管理，加强数据安全域管理，使原始数据不离开数据安全域，可有效防范内部人员盗取数据的风险。另外还对手机号码、身份证号、家庭住址、年龄等敏感数据脱敏工作。</p>
          </div>
          <div class="safty_item">
            <div class="safty_item_img">
              <img src="../assets/images/data_share.png" alt />
            </div>
            <h2>大数据共享及销毁</h2>
            <p>在数据共享时，遵循相关管理制度，有效管理数据共享行为。在数据销毁过程中，通过软件或物理的方式操作，保证磁盘中存储的数据永久删除、不可恢复。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于远达 -->
    <div class="home_item">
      <div class="container yuanda_background">
        <div class="yuanda_img">
          <img src="../assets/images/about_yuanda.png" alt />
        </div>
        <div class="home_item_content">
          <h6>about us</h6>
          <i></i>
          <h1>关于远达</h1>
          <div class="content item_txt">
            <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的高技术企业，是国内领先的物联网系统解决方案提供商，是深受客户信赖的万物物联技术服务提供商。</p>
            <p>有品质才有市场，有创新才有进步。公司以基于信息技术的创新能力为核心竞争力，通过技术创新、管理创新及商业模式创新，致力于围绕5G技术、智能安防、智能制造、智能运动监测、智能供应链定制、工业物联网、智慧城市、人工智能、智能家居、智慧医疗、智慧养老等领域解决方案的开发和应用，通过不断完善产品，筑建极具幸福感的智能生活新时代。</p>
            <p>未来，远达智能将继续完善研发服务标准化体系，融合前沿最新科学技术，让企业和个人在任何时候，任何地方，都能轻松享受万物物联带来的惊喜改变。</p>
          </div>
          <div class="more">
            <router-link tag="a" to="/about/brief" href="#">查看更多</router-link>
            <img src="../assets/images/right.png" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- 成功案例 -->
    <div class="home_item">
      <div class="container cases_flex">
        <div class="home_item_content">
          <h6>Successful cases</h6>
          <i></i>
          <h1>成功案例</h1>
        </div>
        <div class="cases_btn">
          <a @click="preBtn">
            <img src="../assets/images/left.png" alt />
          </a>
          <a @click="nextBtn">
            <img src="../assets/images/right.png" alt />
          </a>
        </div>
        <div class="cases_outbox">
          <ul class="cases_box" ref="cases_box">
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_1.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>销售大神</h3>
                <p>销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_2.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/web_icon.png" alt />
                </div>
                <h3>行业解决方案</h3>
                <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的高技术企业。.5亿家企业信息...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_3.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/hardware_icon.png" alt />
                </div>
                <h3>增氧机硬件设备</h3>
                <p>增氧机是一种常被应用于渔业养殖业的机器。它的主要作用是增加水中的氧气含量以确保水中的鱼类不会缺氧，同时也能抑制水中厌氧菌的生长...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_4.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>奥沙渔业</h3>
                <p>奥沙渔业主要是研发水产养殖方面的物联网，包括三层结构：分别是软件系统（移动APP）、数据分析（数据文档）、硬件系统（物联网控制模块）。</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_5.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/web_icon.png" alt />
                </div>
                <h3>一毛共享</h3>
                <p>
                  一毛共享是一款集商业推广、网上购物于一体的，个性化电子海报智能分发平台。
                  <br />商家通过红包的形式投放自己的海报，让精准用户...
                </p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_6.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/hardware_icon.png" alt />
                </div>
                <h3>良境</h3>
                <p>“良境”是良境（深圳）网络科技有限公司开发的一款通过构建美陈、景观、装饰、灯光、花艺的空间设计行业垂直生态平台，满足行业内人士...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_7.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>万物物联</h3>
                <p>万物物联也称智慧物联，主要指的是为所有硬件的联网，提供一整套系统性的解决方案。其应用范围覆盖了个人穿戴、家庭安防、智慧出行、智慧农业...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_8.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>未来智能箱</h3>
                <p>未来智能箱是公司自主研发搭配智能模块，通过蓝牙通信技术、网路安全加密技术实现智能箱的定位功能、开箱功能可联网集中管理智能箱...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_9.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>赤商风采</h3>
                <p>为赤峰商会会员提供了信息交流的平台。每位注册用户可通过app设置自己旗下公司的信息，加入商会、收藏感兴趣的人，也可给自己设定个人风采。</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_1.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/iphone_icon.png" alt />
                </div>
                <h3>销售大神</h3>
                <p>销售大神是一款快速为企业匹配目标客户信息，建立快速沟通通道，实现企业快速成交的销售平台，目前已覆盖全国1.5亿家企业信息...</p>
              </div>
            </li>
            <li class="cases_item">
              <div class="cases_img">
                <img src="../assets/images/cases_2.png" alt />
              </div>
              <div class="cases_txt">
                <div class="cases_icon">
                  <img src="../assets/images/web_icon.png" alt />
                </div>
                <h3>行业解决方案</h3>
                <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的高技术企业。.5亿家企业信息...</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 物联资讯 -->
    <div class="home_item">
      <div class="container">
        <div class="home_item_content">
          <h6>informations</h6>
          <i></i>
          <h1>物联资讯</h1>
          <div class="information_img">
            <img src="../assets/images/infomatian_1.png" alt />
            <div class="information_txt">
              <p>2020.01.02</p>
              <h3>Windows远程桌面服务漏洞预警通告</h3>
              <p
                class="txt"
              >2020年01月02日，微软公布了5月的补丁更新列表，其中存在一个被标记为严重的RDP（远程桌面服务）远程代码执行漏洞，攻击者可以利用此漏洞，无需用户验证而发送构造特殊的恶意数据...</p>
            </div>
          </div>
        </div>
        <div class="information">
          <div class="new_btn">
            <router-link tag="a" to="/infomation" href="#">查看更多</router-link>
            <img src="../assets/images/right.png" alt />
          </div>
          <div class="information_new">
            <div class="new_item">
              <img src="../assets/images/new_1.png" alt />
              <div class="new_txt">
                <p>2020.01.01</p>
                <h3>Linux内核中TCP SACK机制远程DoS预警通告</h3>
                <p
                  class="txt"
                >2020年02月01日，RedHat官网发布报告：安全研究人员在Linux内核处理TCP SACK数据包模块中发现了三个漏洞，CVE编号为CVE-2019-11477、CVE-2019-11478和CVE-2019-11479，其中CVE-2019-11477漏洞能够降低系统运行效率，并可能被远程攻击者用于拒绝服务攻击，影响程度严重，建议广大用户及时更新。</p>
              </div>
            </div>
            <div class="new_item">
              <img src="../assets/images/new_2.png" alt />
              <div class="new_txt">
                <p>2019.12.28</p>
                <h3>阿里腾讯抢攻无线 支付与物流成重点</h3>
                <p class="txt">有人曾说过电商“有电而无商”，也有人预言中国的电商企业无法翻越“融资、支付、物流”三座大山。 如今看来这种说法和预言正被电商大佬着力打破。</p>
              </div>
            </div>
            <div class="new_item">
              <img src="../assets/images/new_3.png" alt />
              <div class="new_txt">
                <p>2019.12.25</p>
                <h3>从阿里的“电商江湖”看马云的“变革未来”</h3>
                <p
                  class="txt"
                >引言：阿里江湖中马云的新故事 马云的故事一直不少，而且一般都很大。远的不说，刚刚过去的2012年，因阿里网上交易额突破万亿，其被封“万亿侯”。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      left: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    preBtn() {
      if (this.left <= 0) {
        this.left = 0;
      } else {
        this.left -= 408;
        this.$refs.cases_box.style.left = -this.left + "px";
      }
    },
    nextBtn() {
      if (this.left >= 3264) {
        this.left = 0;
        this.$refs.cases_box.style.left = this.left + "px";
      } else {
        this.left += 408;
        this.$refs.cases_box.style.left = -this.left + "px";
      }
    },
  },
  created() {},
  mounted() {
    this.interval = setInterval(() => {
      this.nextBtn();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed() {},
};
</script>
<style lang="less" scoped>
#home {
  height: 3223px;
}
.banner {
  background: url(../assets/images/banner.png);
  background-repeat: no-repeat;
  background-position: center;
  height: 500px;
  min-width: 1200px;
  background-size: cover;
  position: relative;
  top: 90px;
  margin: 0 0 90px 0;
}
// //万物物联
.home_item {
  height: 800px;

  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    display: flex;

    .wanwu_img {
      position: absolute;
      right: 0;
      /* width: 524px;*/
      width: 50%;
      margin-top: 56px;
      img {
        width: 100%;
      }
    }
    .home_item_content {
      margin-top: 120px;
      width: 43%;

      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        font-weight: 500;
      }
      .wulian {
        margin: 8px 0 40px;
        display: block;
        font-size: 14px;
      }
      .content {
        text-indent: 2em;
        font-size: 14px;
        line-height: 24px;
      }
      .item_txt {
        margin-top: 40px;
      }
      .more {
        margin-top: 40px;
        height: 70px;
        line-height: 70px;
        img {
          margin-left: 20px;
          width: 24px;
          height: 12px;
        }
        &::before {
          content: "";
          display: inline-block;
          width: 52px;
          height: 70px;
          background: rgba(38, 172, 255, 1);
          opacity: 0.18;
          z-index: -1;
          position: absolute;
        }
      }
      .more a {
        padding-left: 24px;
        font-size: 16px;
      }
    }
  }
}

// //智能机器人
.home_item {
  .container {
    .home_item_content {
      .content_2 {
        font-size: 14px;
        line-height: 24px;
        margin-top: 40px;
      }
    }
    .robot_content {
      background: url("../assets/images/home_robot_3.png") no-repeat;
      height: 178px;
      width: 120%;
      text-indent: 2em;

      display: flex;
      align-items: center;
      position: relative;
      left: -206px;
      margin-top: 130px;
      p {
        width: 550px;
        padding: 0 20px;
      }
    }
    .robot_img {
      margin-top: 120px;
      margin-right: 120px;
      position: relative;
      // img:nth-child(1) {
      //   width: 80%;
      // }
      img:nth-child(2) {
        position: absolute;
        right: 62px;
        top: 467px;
      }
    }
  }
}
// // 安全防护，保驾护航
.home_item {
  .container {
    .safty_item_content {
      width: 30%;
    }
    .home_item_content {
      .safty_content {
        width: 300px;
        margin-top: 40px;
      }
    }
    .satfyBox {
      margin-top: 120px;

      display: flex;
      flex-wrap: wrap;
      width: 70%;
    }
    .safty_item {
      width: 48%;
      height: 298px;
      background: rgba(255, 255, 255, 1);
      margin-bottom: 24px;
      margin-right: 10px;
      padding: 30px 30px;

      &:hover {
        box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
      }
      h2 {
        font-size: 20px;
        line-height: 28px;
        margin: 20px 0;
      }
      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}

// //关于远达
.home_item {
  .yuanda_background::after {
    content: "";
    display: inline-block;
    width: 83%;
    height: 636px;
    background: rgba(38, 172, 255, 0.05);
    position: absolute;
    right: 0;
    z-index: -1;
  }
  .container {
    .home_item_content {
      .item_txt {
        margin-top: 40px;
      }
    }
    .yuanda_img {
      margin-right: 102px;
      margin-top: 120px;
    }
  }
}

//成功案例
.home_item {
  .cases_flex {
    flex-direction: column;
    .cases_btn {
      position: absolute;
      right: 0;
      top: 141px;
      img {
        z-index: 10;
      }
      a {
        padding: 20px;
        &:hover {
          background: rgba(38, 172, 255, 0.1);
        }
      }
    }
  }
  .container {
    .cases_outbox {
      width: 1200px;
      height: 600px;
      overflow: hidden;
      position: relative;
      margin: 0 auto;
      .cases_box {
        display: flex;
        margin-top: 40px;
        position: absolute;
        left: 0;

        .cases_item {
          height: 486px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
          opacity: 1;
          border-radius: 15px 15px 0px 0px;
          margin-right: 24px;

          .cases_txt {
            padding: 50px 30px 0 30px;
            position: relative;
            .cases_icon {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background: rgba(38, 172, 255, 1);
              border: 3px solid rgba(253, 252, 251, 1);
              position: absolute;
              top: -30px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            h3 {
              font-size: 20px;
              line-height: 25px;
              color: rgba(64, 64, 64, 1);
            }
            p {
              line-height: 24px;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              margin-top: 10px;
              width: 320px;
            }
          }
        }
      }
    }
  }
}

//物联资讯
.home_item {
  .container {
    .home_item_content {
      .information_img {
        margin-top: 28px;
        position: relative;
      }
      .information_txt {
        width: 446px;
        height: 174px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
        position: absolute;
        left: 20px;
        bottom: -88px;
        padding: 20px;
        h3 {
          line-height: 24px;
          font-size: 18px;
          margin: 10px 0;
        }
        p {
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
        }
        .txt {
          font-size: 14px;
          line-height: 24px;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
    .information {
      margin-top: 156px;
      position: relative;
      .new_btn {
        position: absolute;
        right: 0;
        top: 0;
      }
      .information_new {
        margin-top: 96px;
        .new_item {
          width: 698px;
          height: 150px;

          margin-bottom: 9px;
          display: flex;
          .new_txt {
            padding: 20px;
            h3 {
              line-height: 24px;
              font-size: 18px;
              margin: 10px 0;
            }
            p {
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
            }
            .txt {
              font-size: 14px;
              line-height: 24px;
              color: rgba(153, 153, 153, 1);
              height: 45px;
              width: 506px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
}
</style>